/**
 * 이미지 화질 단계 — next.config images.qualities 와 같은 값만 쓴다(목록 밖 값은 가장 가까운 값으로 바뀐다).
 * - key   100 : 히어로 키비주얼처럼 화면을 크게 채우고 첫눈에 보이는 이미지
 * - scene  90 : 상세·딜 배너·릴스처럼 크게 보이는 장면 컷
 * - card   75 : 카드 썸네일(Next 기본값과 같아 보통 생략)
 * - thumb  60 : 36~56px 아바타처럼 작게 보이는 이미지
 * - blur   30 : 크게 흐려 배경으로 까는 표지(홈 배너 · 상세 · 라운지 상세 머리) — 어차피 뭉개지니 가장 가볍게
 */
export const IMAGE_QUALITY = {
  key: 100,
  scene: 90,
  card: 75,
  thumb: 60,
  blur: 30,
} as const
